import { createSlice } from "@reduxjs/toolkit";

const PageSlice = createSlice({
  name: "page",
  initialState: { value: 0 },
  reducers: {
    next: (state, action) => {
      state.value = state.value + 1;
    },
    back: (state, action) => {
      state.value = state.value - 1;
    },

    start: (state, action) => {
      state.value = 0;
    },
  },
});
export const { back } = PageSlice.actions;
export const { next } = PageSlice.actions;
export const { start } = PageSlice.actions;
export default PageSlice.reducer;